import { CurrencyDollarSimple, Quotes } from "@phosphor-icons/react";
import * as React from "react";
import styles from "../Navbar.module.css";
import chromeIcon from "~/assets/Chrome-icon.svg";
import { ReadMoreLink } from "~/components/DesignSystem/ReadMoreLink";

export interface MobileResourcesContentProps {
  chromeExtensionUrl?: string;
}

export const MobileResourcesContent: React.FC<MobileResourcesContentProps> = ({
  chromeExtensionUrl,
}) => {
  const chromeHref = chromeExtensionUrl || "/chrome-extension";

  return (
    <div className={styles.mobileDropdownContent}>
      <a href="/resources/roi" className={styles.mobileDropdownItem}>
        <div className={`${styles.productIcon} ${styles.roiIcon}`}>
          <CurrencyDollarSimple size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>ROI</span>
          <span className={styles.mobileDropdownItemDescription}>
            See how Vendr delivers measurable savings and ROI for companies of
            all sizes
          </span>
        </div>
      </a>

      <a href="/blog" className={styles.mobileDropdownItem}>
        <div className={`${styles.productIcon} ${styles.blogIcon}`}>
          <Quotes size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>Blog</span>
          <span className={styles.mobileDropdownItemDescription}>
            Read the latest insights, tips, and best practices for procurement
            and negotiations
          </span>
        </div>
      </a>

      {/* Chrome Extension Card - Featured */}
      <a
        href={chromeHref}
        target={chromeExtensionUrl ? "_blank" : undefined}
        rel={chromeExtensionUrl ? "noopener noreferrer" : undefined}
        className={styles.chromeCard}
      >
        <div className={styles.chromeCardContent}>
          <div className={styles.chromeCardText}>
            <span className={styles.chromeCardLabel}>Browser Extension</span>
            <span className={styles.chromeCardTitle}>
              Pricing intel,
              <br />
              everywhere you go
            </span>
          </div>
          <div className={styles.chromeCardVisual}>
            <img src={chromeIcon} alt="" className={styles.chromeCardIcon} />
          </div>
        </div>
        <div className={styles.chromeCardFooter}>
          <ReadMoreLink href={chromeHref} as="span">
            Add to Chrome
          </ReadMoreLink>
        </div>
      </a>
    </div>
  );
};
